import type { ReactNode } from 'react';

/**
 * 홈의 레일 하나 — 제목 + 가로 스크롤 컨테이너 (`docs/63` §2.1 · §6.1).
 *
 * **카드가 없으면 `null` 이다.** 호출자가 아니라 여기서 한 번 지킨다 — `disabled` 카드나 빈
 * 제목이 DOM 에 남으면 포커스가 보이지 않는 자리로 간다(절대 규칙 29 · `docs/63` §11-13).
 * `composeHome` 이 빈 레일을 애초에 내지 않으므로 이것은 둘째 겹이다.
 */
export function Rail({
  id,
  title,
  count,
  children,
}: {
  id: string;
  title: string;
  count: number;
  children: ReactNode;
}) {
  if (count === 0) return null;
  return (
    <section className="home__rail" data-testid={`home-rail-${id}`}>
      <h2 className="home__rail-title">{title}</h2>
      <div className="home__rail-track">{children}</div>
    </section>
  );
}
